// import { Container, makeStyles } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import "./timerText.css";
import moment from "moment";


function CountDownTimerText(props) {
  
  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    
    

    let intervalId = setInterval(function (){
        //var now = moment(new Date());
        //var now = moment(props.Now);
        var now = props.Now;
        const end = props.Time;
        const days = moment(end).diff(now, "days");
        const hours = moment(end).diff(now, "hours") - days * 24;
        const minutes = moment(end).diff(now, "minutes") - days * 1440 - hours * 60;
        const seconds =
          moment(end).diff(now, "seconds") -
          (days * 86400 + hours * 3600 + minutes * 60);

        setTimer({
          days: days > 0 ? days : 0,
          hours: hours > 0 ? hours : 0,
          minutes: minutes > 0 ? minutes : 0,
          seconds: seconds > 0 ? seconds : 0
        });
        
      }, 1000);

      if(intervalId != null){
        return () => {
          clearInterval(intervalId);
        };
      }
      

  }, [props.Time]);

  if(props.OnlyMinutesAndSeconds){
    return (timer.minutes+ 'm' + ' ' +       
      timer.seconds+ 's'            
      );
  }

  return (timer.days + 'd' + ' ' +
  timer.hours+ 'h' + ' ' +        
  timer.minutes+ 'm' + ' ' +       
  timer.seconds+ 's'            
  );
}

export default CountDownTimerText;
